export default __webpack_public_path__ + "static/media/car.25ce788a.svg";